export default "__VITE_ASSET__5de33a00__"